import React from 'react';
import config from '../../config/config.json';
import Submenu from './Submenu';
import MenuOption from './MenuOption';
import { getAgentAllowProducts } from '../SentBudgets/agentBudgets';

const NO_PRODUCT_SELECTED = -1;
const MIN_WIDTH_PIXEL_DESKTOP = 768;

export class Menu extends React.PureComponent {
  constructor(props) {
    super(props);
    const agentId = props.agentId;
    this.state = {
      visibleSubmenu: NO_PRODUCT_SELECTED,
      viewportWidth: 0,
      permisos: [],
      agentId: agentId,
    };
    this.loadAllowProducts();
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    this.setState({ viewportWidth: window.innerWidth });
  };

  onMenuClick = (position) => {
    this.setState({
      visibleSubmenu:
        this.state.visibleSubmenu === position ? NO_PRODUCT_SELECTED : position,
    });
  };

  onSubmenuClick = () => {
    this.setState({
      visibleSubmenu: NO_PRODUCT_SELECTED,
    });
  };

  onSelectChange = (product) => {
    const qparams = this.getQueryParams();
    this.navigate('/presupuesto/' + product + qparams);
  };

  navigate = (url) => {
    this.props.budgetRouteRef.context.router.history.push(url);
  };

  getQueryParams = () => {
    try {
      return this.props.budgetRouteRef.context.router.history.location.search;
    } catch (e) {
      return null;
    }
  };

  loadAllowProducts = async () => {
    try {
      const permisos = await getAgentAllowProducts(this.state.agentId);
      this.setState({ permisos: permisos });
    } catch (error) {
      this.setState({ loading: false });
      alert('Se ha producido un error al cargar los permisos.');
      console.error(error);
    }
  };

  filterFamiliesAllow = () => {
    const families = config.families;
    let familiesAllowed = [];

    this.state.permisos.forEach((familyPermiso) => {
      let family = families.find(
        (element) => element.path === familyPermiso.family
      );
      family.products = [];
      if (family) {
        familyPermiso.products.forEach((productPermiso, i) => {
          family.products[i] = productPermiso.product;
        });
        familiesAllowed.push(family);
      }
    });

    return familiesAllowed;
  };

  render() {
    const families = this.filterFamiliesAllow();
    const qparams = this.getQueryParams();
    const productList = families.flatMap(family => family.products)

    return this.state.viewportWidth >= MIN_WIDTH_PIXEL_DESKTOP ? (
      <div>
        <nav className="main-menu ">
          <ul className="main-menu__wrapper">
            {families.map((family, i) => (
              <li
                key={i}
                className={`theme-${family.theme} main-menu__option `}
              >
                <MenuOption
                  position={i}
                  family={family}
                  qparams={qparams}
                  onMenuClick={this.onMenuClick}
                />
              </li>
            ))}
          </ul>
          {families.map((fam, i) => (
            <Submenu
              key={i}
              theme={families[i].theme}
              isVisibleSubmenu={this.state.visibleSubmenu === i}
              productsMenu={config.families[i].products}
              qparams={qparams}
              handleClick={this.onSubmenuClick}
            />
          ))}
        </nav>
      </div>
    ) : (
      <div
        style={{
          backgroundColor: 'white',
          display: 'flex',
          justifyContent: 'center',
          padding: '20px',
        }}
      >
        <div className="form-field u-margin-bottom-none">
          <div className="form-control">
            Calcula cuanto te costaría tu seguro de
            <div className="form-select">
              <select
                defaultValue={'seleccionar'}
                onChange={(evt) => this.onSelectChange(evt.target.value)}
              >
                <option value="seleccionar" disabled>
                  seleccionar
                </option>
                {productList.map((productName, i) => (
                  <option key={i} value={productName}>
                    {productName}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/components/HorizontalMenu/index.js